import { TOKEN_KEY } from './cookie';

export const isMobileLandscape = (): boolean => {
  // 新版浏览器可使用 window.screen.orientation
  if (window.screen.orientation) {
    const { type } = window.screen.orientation
    if (type.includes('landscape')) {
      return true
    }
  } else {
    // 兼容老版本
    if (window.orientation === 180 || window.orientation === 0) {
      return false
    }
    // 横屏状态
    if (window.orientation === 90 || window.orientation === -90) {
      return true
    }
  }
  return false
}

// 如果是移动端横屏状态，isPC会返回true。增加isPure参数，用来判断纯正的PC端
export const isPC = (isPure: boolean = false): boolean => {
  const userAgentInfo = navigator.userAgent
  const Agents = [
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod',
  ]
  let flag = true
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = isPure ? false : isMobileLandscape()
      break
    }
  }
  return flag
}

export const isAndroid = (): boolean => {
  return Boolean(navigator.userAgent.match(/android/gi))
}

export const isIos = (): boolean => {
  return Boolean(navigator.userAgent.match(/iPhone|iPad/gi))
}

export const isInFacebookWebView = () => {
  return /(FBAN|FBAV)\/\w+/.test(navigator.userAgent)
}

export const authToken = () => {
  const accountInfo = JSON.parse(localStorage.getItem(TOKEN_KEY) || '{}');
  console.log(accountInfo?.expired_at);
  console.log(~~(+new Date() / 1000));
  return accountInfo?.expired_at > ~~(+new Date() / 1000)
}

export const timeOver = (endDate = '2024-06-03 23:59:59') => {
  const nowTime = new Date().getTime()
  const lastCheckTime = new Date(endDate).getTime()
  return nowTime >= lastCheckTime
}

export const openPage = (url) => {
  const page = window.open(url);
  if (!page) {
    window.location.href = url;
  }
};

export const getHrefParam = () => {
  const location = decodeURIComponent(window.location.href)
  if (location.indexOf('?') < 0) {
    return {}
  }
  const paramStr = location.split('?')[1]
  const res = {}
  if (paramStr) {
    paramStr.split('&').forEach((item) => {
      const [key, value] = item.split('=')
      res[key] = value
    })
  }
  return res
}
